/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    LOAD_APP,
    SET_BRAND_CONFIG,
    SET_FEATURE_FLAG,
} from './App-ActionTypes';

export const loadApp = () => ({
    type: LOAD_APP,
});

export const setBrandConfig = (data) => ({
    type: SET_BRAND_CONFIG,
    payload: data,
});

export const setFeatureFlag = (data) => ({
    type: SET_FEATURE_FLAG,
    payload: data,
});

export default {};
